import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=18fa600a&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=18fa600a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa600a",
  null
  
)

export default component.exports